import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, ViewRef } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.scss']
})
export class AudioPlayerComponent implements OnInit {

  @Input() audioURL: SafeUrl | String;
  @Input() duration: number;
  @Input() inputColor: string;
  @Input() backgroundColor: string;

  @ViewChild('audio')
  audio: ElementRef;

  currentTimeRange: number;

  intervalCurrentTime: any;


  constructor(
        private elRef: ElementRef,
        private ref: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.currentTimeRange = 0;
      if(this.inputColor){
        this.elRef.nativeElement.style.setProperty('--offer-color', this.inputColor);
      }
      this.elRef.nativeElement.style.setProperty('--background-color', this.backgroundColor !== undefined ? this.backgroundColor : '#fff');
  }

  toSeconds(time: number) {
    let duration = time;

    duration = duration % (3600);

    let min: any = duration / 60;
    duration = duration % (60);

    let sec: any = duration;

    if (sec < 10) {
      sec = `0${sec}`;
    }
    if (min < 10) {
      min = `${min}`;
    }
    let minString: string = '' + min;
    let secString: string = '' + sec;
    return (`${minString.substring(0, minString.length - (minString.length - 1))}:${secString.substring(0, secString.length - (secString.length - 2))}`)
  }

  playAudio(): void {
    if (this.audio.nativeElement.duration > 0 && !this.audio.nativeElement.paused) {
      this.audio.nativeElement.pause();
      clearInterval(this.intervalCurrentTime)
    } else {
      this.audio.nativeElement.play();
      this.currentTimeRange = this.currentTimeRange == undefined ? 0 : this.currentTimeRange;
      this.intervalCurrentTime = setInterval(() => {
        this.setPercentageValue();
        this.currentTimeRange = this.audio.nativeElement.currentTime;
        if (this.ref && !(this.ref as ViewRef).destroyed) {
          this.ref.detectChanges();
        }
      }, 250)
    }
    this.ref.detectChanges();
  }

  setPercentageValue(): void {
    const currentTime = this.audio ? this.audio.nativeElement.currentTime : 0;
    const duration = this.duration ? this.duration : 0;
    let percent = (currentTime * 100) / duration;
    this.elRef.nativeElement.style.setProperty('--percentage-color', percent + '%');
    this.elRef.nativeElement.style.setProperty('--percentage-transparent', '1%');

  }

  muteAudio(): void {
    this.audio.nativeElement.muted = !this.audio.nativeElement.muted;
  }

  stopedAudio() {
    clearInterval(this.intervalCurrentTime);
    this.ref.detectChanges();
    this.currentTimeRange = this.duration;
  }
  
  getDuration(event): void {
    if (event.currentTarget.duration !== Infinity) {
      this.duration = Math.trunc(event.currentTarget.duration);
    }
    this.ref.detectChanges();
  }
}
